import { render, staticRenderFns } from "./DashOptions.vue?vue&type=template&id=c616c3de&"
import script from "./DashOptions.vue?vue&type=script&lang=js&"
export * from "./DashOptions.vue?vue&type=script&lang=js&"
import style0 from "./DashOptions.vue?vue&type=style&index=0&id=c616c3de&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports